import { useEffect, useState } from "react"

// Debounce a rapidly-changing value (e.g. a search input) so we don't fire a
// query on every keystroke. Server-side search on large orgs is the reason.
export const useDebouncedValue = <T,>(value: T, delayMs = 300): T => {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
